class DeliveryRules {
  static getToday() {
    return new Date();
  }

  // Parse hour robustly (handles 12h/24h formats like "2:00 PM", "2 PM", "14:00", " 14 ")
  static parseHour(timeStr) {
    if (typeof timeStr !== 'string') return 14;
    const cleanStr = timeStr.trim().toLowerCase();
    const isPm = cleanStr.includes('pm');
    const isAm = cleanStr.includes('am');
    
    const parts = cleanStr.split(':');
    let hour = parseInt(parts[0].replace(/[^0-9]/g, ''), 10);
    
    if (isNaN(hour)) return 14;
    
    if (isPm && hour < 12) {
      hour += 12;
    } else if (isAm && hour === 12) {
      hour = 0;
    }
    return hour;
  }

  // Get current time in local timezone
  static getStoreCurrentTime(timeZone) {
    const now = new Date();
    return {
      hours: now.getHours() % 24,
      minutes: now.getMinutes()
    };
  }

  // Get current date string (YYYY-MM-DD) in local timezone
  static getStoreTodayStr(timeZone) {
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  // Rule 3: make dates after 6 weeks disabled
  static getMaxDate(timezone = 'UTC') {
    const todayStr = this.getStoreTodayStr(timezone);
    const [year, month, day] = todayStr.split('-').map(Number);
    const max = new Date(year, month - 1, day);
    max.setDate(max.getDate() + 42); // 6 weeks = 42 days
    return max;
  }

  // Rule 1 & 4: Get closest valid date (excluding Sundays, respecting same-day cut-off)
  static getClosestValidDate(cutoffTimeStr = '14:00', timezone = 'UTC') {
    const todayStr = this.getStoreTodayStr(timezone);
    const [year, month, day] = todayStr.split('-').map(Number);
    const closest = new Date(year, month - 1, day);

    const cutoffHour = this.parseHour(cutoffTimeStr);
    const storeTime = this.getStoreCurrentTime(timezone);

    if (storeTime.hours >= cutoffHour) {
      closest.setDate(closest.getDate() + 1);
    }

    // Rule 4: If date is Sunday (0), shift to next day (Monday)
    while (closest.getDay() === 0) {
      closest.setDate(closest.getDate() + 1);
    }

    return closest;
  }

  // Rule 1: Get closest time slot based on selected date
  static getClosestTimeSlot(selectedDateStr, timezone = 'UTC') {
    const todayStr = this.getStoreTodayStr(timezone);

    if (selectedDateStr === todayStr) {
      const storeTime = this.getStoreCurrentTime(timezone);
      // If today and past 9:00 AM, the closest valid slot is the afternoon slot
      if (storeTime.hours >= 9) {
        return '2:00 PM - 6:00 PM';
      }
    }
    // Default to morning slot
    return '9:00 AM - 4:00 PM';
  }

  // Rule 2: Check if a time slot is disabled based on selected date and current time
  static isTimeSlotDisabled(slot, selectedDateStr, cutoffTimeStr = '14:00', timezone = 'UTC') {
    const todayStr = this.getStoreTodayStr(timezone);

    if (selectedDateStr === todayStr) {
      const storeTime = this.getStoreCurrentTime(timezone);
      
      if (slot === '9:00 AM - 4:00 PM' && storeTime.hours >= 9) {
        return true;
      }
      if (slot === '2:00 PM - 6:00 PM') {
        const cutoffHour = this.parseHour(cutoffTimeStr);
        if (storeTime.hours >= cutoffHour) {
          return true;
        }
      }
    }
    return false;
  }

  // Rule 4: Check if Sunday
  static isSunday(date) {
    return date.getDay() === 0;
  }

  // Helper: Format Date to YYYY-MM-DD
  static formatDate(date) {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }
}

// Bind to window to make it accessible to custom elements
window.DeliveryRules = DeliveryRules;
